import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { SlideDown } from "react-slidedown";

import ScrollLock from "react-scrolllock";

import { Grid, Cell } from "../basic/layouts/Grid";
import Text from "../basic/Text";
import Button from "../basic/Button";
import Link from "../util/link";
import getCookie from "../basic/helper-functions/getCookie";
import setCookie from "../basic/helper-functions/setCookie";
import hotjarTrigger from "../basic/helper-functions/hotjarTrigger";
import Event from "../util/GAEvent";

import HalfCircle from "../../images/color-splashes/filled-splashes/HalfCircle1.svg";
import Triangle from "../../images/color-splashes/filled-splashes/Triangle1.svg";
import BlackCloseButton from "../../images/icons/x-button-black.svg";
import theme from "../../styles/theme";

import "react-slidedown/lib/slidedown.css";

const {
	colors,
	breakPoints: { screenQuery, mobileFirstScreenQuery },
} = theme;
const isClient = typeof window === "object";

const listImage =
	"https://images.ctfassets.net/n3ohnvkomoi9/5wKrR1CddC8e6eY4UqI2CC/3ae36b675ce463f385d576bb9f5714db/Icons_UseCase_EmployeeSurveys.svg";
const chatImage =
	"https://images.ctfassets.net/n3ohnvkomoi9/6eYGKg1sMaQSVAnxU1FfOK/c95dcbf62d54d566bdf5ee6199c5c7a5/Icons_UseCase_Inquiry_management.svg";

const StyledSlideDown = styled(SlideDown)`
	position: absolute;
	background-color: ${colors.grayscale.stone};
	z-index: 9;
	width: 100%;
	/* box-shadow: ${theme.cardBoxShadow}; */
	transition-duration: 0.8s;
`;

const Wrapper = styled.div`
	padding: 80px 4px;
	height: calc(100vh - 75px) !important;
	width: 90%;
	max-width: 1100px;
	margin: 0 auto;
	overflow-y: auto;
	::-webkit-scrollbar {
		display: none;
	}
`;

const Card = styled(Cell)`
	background-color: ${colors.grayscale.white};
	box-shadow: ${theme.cardBoxShadow};
	padding: 30px;
	text-align: center;
	width: 100%;
`;
const Header = styled(Cell)`
	width: 100%;
`;

const Close = styled.img`
	margin-right: 10px;
	width: 17px;
	height: 17px;
	padding: 1x;
	border: 1px solid ${colors.grayscale.black};
	border-radius: 100%;
	:hover {
		cursor: pointer;
	}

	transform: scale(1);
	:hover {
		animation: pulse 2s infinite;
	}
	@keyframes pulse {
		0% {
			transform: scale(0.9);
			box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
		}
		50% {
			transform: scale(1.1);
			box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
		}
		100% {
			transform: scale(0.9);
			box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
		}
	}
`;

const BackSplash = styled.div`
	background: url(${(props) => props.background}) center no-repeat;
	/* background-size: 50%; */
	background-size: contain;
	margin-bottom: 24px;
	img {
		min-height: 120px;
	}
`;

const StyledButton = styled(Button)`
	font-size: 1.2em;
	padding: 8px 16px;
`;

const ClosePrompt = styled.div`
	display: none;

	${mobileFirstScreenQuery.medium} {
		display: flex;
	}
`;

const ClosePromptMobile = styled.div`
	margin: 20px 0;
	background-color: ${colors.secondary.lighter};
	padding: 5px;
	p {
		font-size: 14px;
	}

	${mobileFirstScreenQuery.medium} {
		display: none;
	}
`;

export default () => {
	const [showTakeover, setShowTakeover] = useState(false);

	useEffect(() => {
		// console.log(getCookie('ref_orgsubmit'), getCookie('seen_homepage_takeover'))
		let isSubmitter = false;
		if (getCookie("seen_homepage_takeover")) {
			console.log("has seen homepage takeover, not showing");
		} else {
			if (isClient && document.cookie.indexOf("ref_orgsubmit=") >= 0) {
				isSubmitter = true;
			}
			// else if (getCookie('redirect_www_to')) {
			//     const cookieValue = readCookie(getCookie('redirect_www_to'))
			//     isSubmitter = cookieValue.user_type === "submitter"
			// }
			if (isSubmitter) {
				hotjarTrigger("homepage_takeover");
				setShowTakeover(true);
				setCookie("seen_homepage_takeover", "true");
			}
		}
	}, []);

	// useEffect(() => {
	//     setTimeout(() => {
	//         show(true)
	//     }, 50)
	// }, [])

	return (
		<StyledSlideDown>
			{showTakeover ? (
				<ScrollLock>
					<Wrapper topBottomSpace="80px">
						<Grid>
							<Header span={4}>
								<Text component="h2">Welcome to Submittable</Text>
								<Text component="b2">
									Are you applying for a grant? Trying to submit a form? We’re here to help.
								</Text>
								<ClosePromptMobile onClick={() => setShowTakeover(false)}>
									<Event
										action={`Clicked "I'm here to look at using Submittable" close button`}
										category="User"
										label={getCookie("redirect_www_to") || getCookie("ref_orgsubmit")}
									>
										<Close className="overlay-close-button" src={BlackCloseButton} />
										<Text component="b5" style={{ display: "inline" }}>
											No, thanks. I’m here to look at using Submittable to collect applications or
											submissions for my organization.
										</Text>
									</Event>
								</ClosePromptMobile>
							</Header>

							<Card span={4} spanMd={6} inlineMd>
								<BackSplash background={HalfCircle}>
									<img src={listImage} />
								</BackSplash>
								<Text component="h5">How to apply</Text>
								<Text component="b5" style={{ marginBottom: 35 }}>
									Create a free Submittable account and return to the application page to submit.
								</Text>
								<Event
									action={`Clicked "CREATE AN ACCOUNT" on takeover`}
									category="User"
									label={getCookie("redirect_www_to") || getCookie("ref_orgsubmit")}
								>
									<StyledButton
										link="https://manager.submittable.com/signup"
										style={{ marginBottom: 25 }}
									>
										CREATE AN ACCOUNT
									</StyledButton>
								</Event>

								<Text component="caps">
									<Event
										action={`Clicked "Learn more" on takeover`}
										category="User"
										label={getCookie("redirect_www_to") || getCookie("ref_orgsubmit")}
									>
										<Link
											to="https://submittable.help/en/articles/4058469-getting-started-as-a-submitter"
											hovercolor="brandMain"
										>
											learn more →
										</Link>
									</Event>
								</Text>
							</Card>

							<Card span={4} spanMd={6} inlineMd>
								<BackSplash background={Triangle}>
									<img src={chatImage} />
								</BackSplash>
								<Text component="h5">Need help?</Text>
								<Text component="b5" style={{ marginBottom: 35 }}>
									Our technical support team and help center are here for you.
								</Text>
								<Event
									action={`Clicked "Visit support page" on takeover`}
									category="User"
									label={getCookie("redirect_www_to") || getCookie("ref_orgsubmit")}
								>
									<StyledButton link="/help/submitter/">Visit support page</StyledButton>
								</Event>
							</Card>
							<Cell span={8} start={5}>
								<ClosePrompt>
									<Event
										action={`Clicked "I'm here to look at using Submittable" close button`}
										category="User"
										label={getCookie("redirect_www_to") || getCookie("ref_orgsubmit")}
									>
										<Close
											className="overlay-close-button"
											onClick={() => setShowTakeover(false)}
											src={BlackCloseButton}
										/>
									</Event>
									<Text component="b5" style={{ display: "inline" }}>
										No, thanks. I’m here to look at using Submittable to collect applications or
										submissions for my organization.
									</Text>
								</ClosePrompt>
							</Cell>
						</Grid>
					</Wrapper>
				</ScrollLock>
			) : null}
		</StyledSlideDown>
	);
};
